import styled, { css, SimpleInterpolation } from 'styled-components';

import Media from '../../../assets/styles/media';
import THEME from '../../../assets/styles/config';

export const FilterListCtn = styled.span`
  display: flex;
  flex-wrap: wrap;
`;

export const SectionTitle = styled.span`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
  display: block;

  ${Media.Below.desktopLarge`
    font-size: 20px;
  `}
`;
